import _taggedTemplateLiteral from "/tmp/build_92115aed/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/tmp/build_92115aed/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_92115aed/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
// Simple caching for constant-radius points.
var cacheDigits, cacheAppend, cacheRadius, cacheCircle;
var PathString = /*#__PURE__*/function () {
  function PathString(digits) {
    _classCallCheck(this, PathString);
    this._append = digits == null ? append : appendRound(digits);
    this._radius = 4.5;
    this._ = "";
  }
  _createClass(PathString, [{
    key: "pointRadius",
    value: function pointRadius(_) {
      this._radius = +_;
      return this;
    }
  }, {
    key: "polygonStart",
    value: function polygonStart() {
      this._line = 0;
    }
  }, {
    key: "polygonEnd",
    value: function polygonEnd() {
      this._line = NaN;
    }
  }, {
    key: "lineStart",
    value: function lineStart() {
      this._point = 0;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd() {
      if (this._line === 0) this._ += "Z";
      this._point = NaN;
    }
  }, {
    key: "point",
    value: function point(x, y) {
      switch (this._point) {
        case 0:
          {
            this._append(_templateObject || (_templateObject = _taggedTemplateLiteral(["M", ",", ""])), x, y);
            this._point = 1;
            break;
          }
        case 1:
          {
            this._append(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["L", ",", ""])), x, y);
            break;
          }
        default:
          {
            this._append(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["M", ",", ""])), x, y);
            if (this._radius !== cacheRadius || this._append !== cacheAppend) {
              var r = this._radius;
              var s = this._;
              this._ = ""; // stash the old string so we can cache the circle path fragment
              this._append(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["m0,", "a", ",", " 0 1,1 0,", "a", ",", " 0 1,1 0,", "z"])), r, r, r, -2 * r, r, r, 2 * r);
              cacheRadius = r;
              cacheAppend = this._append;
              cacheCircle = this._;
              this._ = s;
            }
            this._ += cacheCircle;
            break;
          }
      }
    }
  }, {
    key: "result",
    value: function result() {
      var result = this._;
      this._ = "";
      return result.length ? result : null;
    }
  }]);
  return PathString;
}();
export { PathString as default };
function append(strings) {
  var i = 1;
  this._ += strings[0];
  for (var j = strings.length; i < j; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  var d = Math.floor(digits);
  if (!(d >= 0)) throw new RangeError("invalid digits: ".concat(digits));
  if (d > 15) return append;
  if (d !== cacheDigits) {
    var k = Math.pow(10, d);
    cacheDigits = d;
    cacheAppend = function append(strings) {
      var i = 1;
      this._ += strings[0];
      for (var j = strings.length; i < j; ++i) {
        this._ += Math.round(arguments[i] * k) / k + strings[i];
      }
    };
  }
  return cacheAppend;
}